module.exports = __webpack_public_path__ + "static/media/on-eye_fresh-Blue.0aadb530.jpg";